export default {
  regionId: 965821303,
  token: 'edb33e4b13a86e50f88ed8655c3f6305',
  src: 'https://cpa.ostrovok.ru/static/widget/scripts/edb33e4b13a86e50f88ed8655c3f6305.js',
  regionName: 'Железноводск, Россия'
}
